import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';

export function ErrorCodeResolutions(item: SmartSendItemApiModel): string[] {
  const output = item.State?.validation?.Errors || [];
  if (!output || output.length == 0) {
    return [];
  }

  // Add additional errors which might could be the cause of this issue
  if (output.includes('SERVICE-UNAVAILABLE')) {
    return ['SERVICE-UNAVAILABLE', 'ITEM-DIMENSIONS-CHANGE'];
  }

  if (output.includes('ADDRESS-RECIPIENT-SAMEEMAIL-SHOP-DELIVERY')) {
    return ['ADDRESS-RECIPIENT-SAMEEMAIL-SHOP-DELIVERY', 'SERVICE-CHANGE'];
  }

  if (output.includes('ADDRESS-RECIPIENT-SAMEEMAIL-LOCKER-DELIVERY')) {
    return ['ADDRESS-RECIPIENT-SAMEEMAIL-LOCKER-DELIVERY', 'SERVICE-CHANGE'];
  }

  if (output.includes('SERVICE-MULTIPARCEL-UNSUPPORTED')) {
    return ['SERVICE-MULTIPARCEL-UNSUPPORTED', 'SERVICE-CHANGE'];
  }

  return [output[0]];
}
